import { z } from "zod";

export const loginSchema = z.object({
	email: z
		.string()
		.min(1, "El email es requerido")
		.email("Ingresa un email válido"),
	password: z.string().min(6, "La contraseña debe tener al menos 6 caracteres"),
});

export type LoginFormValues = z.infer<typeof loginSchema>;

export const changePasswordSchema = z
	.object({
		currentPassword: z.string().min(1, "La contraseña actual es requerida"),
		newPassword: z
			.string()
			.min(8, "La nueva contraseña debe tener al menos 8 caracteres")
			.max(128, "La nueva contraseña no puede exceder 128 caracteres"),
		confirmPassword: z.string().min(1, "Confirma la nueva contraseña"),
	})
	.refine((data) => data.newPassword === data.confirmPassword, {
		message: "Las contraseñas no coinciden",
		path: ["confirmPassword"],
	});

export type ChangePasswordFormValues = z.infer<typeof changePasswordSchema>;
